/** @jsx jsx */
import { css, jsx } from '@compiled/react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import imgSVG from './assets/agent-overview-page-skeleton.tpl.svg';

const customCssStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		borderRightWidth: '24px',
		borderLeftWidth: '24px',
	},
});

export const AgentOverviewPageSkeleton = () => (
	<AppSkeletonImage src={imgSVG} css={customCssStyles} />
);
